import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import BatchRecordsOverview from 'components/BatchRecordsOverview';
import T from 'prop-types';
import withLoadingState from '../../helpers/withLoadingState';
import { PaginationResponse } from '../../helpers/propTypes';
import { PageHeader, PageHeaderTitle } from '../Machines/elements';

const BatchRecords = ({ data }) => {
  const { t } = useTranslation();

  if (!data || !data.data) {
    return null;
  }

  return (
    <>
      <PageHeader alwaysVisible>
        <PageHeader.Title>
          <PageHeaderTitle>{t('batch_records.title')}</PageHeaderTitle>
          <Typography component="span" color="text.secondary" sx={{ fontSize: 14 }}>
            {t('batch_records.subtitle')}
          </Typography>
        </PageHeader.Title>
      </PageHeader>

      <BatchRecordsOverview rows={data} />
    </>
  );
};

BatchRecords.propTypes = {
  data: T.shape(PaginationResponse)
};

BatchRecords.defaultProps = {
  data: null
};

export default withLoadingState(BatchRecords);
